// src/modules/Shop/components/ProductGrid.js
import React from 'react';
import styled from 'styled-components';
import ProductCard from './ProductCard';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

const EmptyState = styled.div`
  grid-column: 1 / -1;
  text-align: center;
  padding: 48px 24px;
  color: #666;

  h3 {
    font-size: 18px;
    color: #333;
    margin-bottom: 8px;
  }

  p {
    font-size: 14px;
  }
`;

const LoadingGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const SkeletonCard = styled.div`
  background: white;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #eee;
`;

const SkeletonImage = styled.div`
  aspect-ratio: 1;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;

  @keyframes shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
`;

const SkeletonContent = styled.div`
  padding: 16px;
`;

const SkeletonLine = styled.div`
  height: ${props => props.$height || '16px'};
  width: ${props => props.$width || '100%'};
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
  margin-bottom: ${props => props.$mb || '8px'};
`;

const ProductGrid = ({ products, loading = false, onWishlistToggle, wishlistedIds = [] }) => {
  if (loading) {
    return (
      <LoadingGrid>
        {[...Array(8)].map((_, i) => (
          <SkeletonCard key={i}>
            <SkeletonImage />
            <SkeletonContent>
              <SkeletonLine $height="12px" $width="60%" />
              <SkeletonLine $height="18px" $width="90%" />
              <SkeletonLine $height="24px" $width="40%" $mb="4px" />
              <SkeletonLine $height="12px" $width="70%" />
            </SkeletonContent>
          </SkeletonCard>
        ))}
      </LoadingGrid>
    );
  }

  if (!products || products.length === 0) {
    return (
      <Grid>
        <EmptyState>
          <h3>Nenhum produto encontrado</h3>
          <p>Tente ajustar os filtros ou buscar por outro termo.</p>
        </EmptyState>
      </Grid>
    );
  }

  return (
    <Grid>
      {products.map(product => (
        <ProductCard
          key={product.id}
          product={product}
          onWishlistToggle={onWishlistToggle}
          isWishlisted={wishlistedIds.includes(product.id)}
        />
      ))}
    </Grid>
  );
};

export default ProductGrid;
